import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BlockNotasPMModel } from '../model/BlockNotasPM.model';
import { DatosEncuestaActaPM } from '../model/DatosEncuestaActa.model';

import { StorageService } from './storage.service';

const getActaJardinTutorPlanMejora = 'planMejora/getActaJardinTutorPlanMejora/';
const getEtapasPlanMejoraJardin = 'planMejora/getEtapasPlanMejoraJardin/';
const firmaActaJardinPlanMejora = 'planMejora/firmaActaJardinPlanMejora/';

const getEstadoGeneralUE = 'planMejora/getEstadoGeneralUE/';
const setEstadoGeneralUE = 'planMejora/setEstadoGeneralUE/';

const getEstadosPlanMejora = 'planMejora/getEstadosPlanMejora/';

const faseEstrategica = 'planMejora/getFaseEstrategica/';
const guardarFaseEstrategica = 'planMejora/guardarFaseEstrategica/';
const finalizarFaseEstrategica = 'planMejora/finalizarFaseEstrategica/';

const borrarObjetivoFaseEstrategica = 'planMejora/borrarObjetivoFaseEstrategica/';

const faseAnual = 'planMejora/getFaseAnualPME/';
const guardarFaseAnual = 'planMejora/guardarAccionesFaseAnualPME/';
const finalizarFaseAnual = 'planMejora/finalizarFaseAnualPME/';

const guardarFaseAnualSeguimiento = 'planMejora/guardarSeguimientoFaseAnualPME/';
const finalizarFaseAnualSeguimiento = 'planMejora/finalizarSeguimientoAnualPME/';

const borrarAccionesFaseAnual = 'planMejora/borrarAccionesFaseAnual/';

const getEstadosFaseAnualAnio = 'planMejora/getEstadosFaseAnualAnio/';

const crearBlockNotaPM = 'planMejora/crearBlockNota/'
const deleteBlockNotaPM = 'planMejora/deleteBlockNota/'
const actualizarBlockNotaPM = 'planMejora/actualizarBlockNota'


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  
const httpOptionsFile = {

  headers: new HttpHeaders({    
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
}; 
@Injectable({
  providedIn: 'root'
})
export class PlanMejoraService {

  constructor(private http:HttpClient,private storageService: StorageService) { }

  API_POST_getActaJardinTutorPlanMejora(idJardinPeriodo: number, numeroActa: number) {
    return this.http.post(environment.apiEndpoint + getActaJardinTutorPlanMejora + idJardinPeriodo + "/" + numeroActa , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getEtapasPlanMejoraJardin(idUsuario: number) {
    return this.http.post(environment.apiEndpoint + getEtapasPlanMejoraJardin + idUsuario, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_firmaActaJardinPlanMejora(datosEncuestaActaPm: DatosEncuestaActaPM) {
    return this.http.post(environment.apiEndpoint + firmaActaJardinPlanMejora , datosEncuestaActaPm, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getEstadoGeneralUE(idJardin: number) {
    return this.http.post(environment.apiEndpoint + getEstadoGeneralUE + idJardin, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_setEstadoGeneralUE(idJardin: number, idEstadoGeneral:number) {
    return this.http.post(environment.apiEndpoint + setEstadoGeneralUE + idJardin + "/" + idEstadoGeneral, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getEstadosPlanMejora(idJardin: number) {
    return this.http.post(environment.apiEndpoint + getEstadosPlanMejora + idJardin, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getEstadosFaseAnualAnio(idJardin: number) {
    return this.http.post(environment.apiEndpoint + getEstadosFaseAnualAnio + idJardin, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

   //Fase Estrategica
  API_POST_getFaseEstrategica(idJardin: number) {
    return this.http.post(environment.apiEndpoint + faseEstrategica + idJardin, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_guardarFaseEstrategica(idJardin:number, FaseEstrategicaJardinPMDTO){    
    return this.http.post(environment.apiEndpoint + guardarFaseEstrategica + idJardin, FaseEstrategicaJardinPMDTO, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_finalizarFaseEstrategica(idJardin:number){    
    return this.http.post(environment.apiEndpoint + finalizarFaseEstrategica + idJardin, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_borrarObjetivoFaseEstrategica(idJardin:number, idObjetivo:number){    
    return this.http.post(environment.apiEndpoint + borrarObjetivoFaseEstrategica + idJardin + "/" + idObjetivo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  //Fase Anual
  API_POST_getFaseAnual(idJardin: number) {
    return this.http.post(environment.apiEndpoint + faseAnual + idJardin, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_guardarFaseAnual(idJardin:number,idAnioFase:number,orden:number, FaseAnualDTO){    
    return this.http.post(environment.apiEndpoint + guardarFaseAnual + idJardin+ "/" + idAnioFase + "/" + orden, FaseAnualDTO, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_guardarFaseAnualSeguimiento(idJardin:number,idAnioFase:number,orden:number, FaseAnualDTO){    
    return this.http.post(environment.apiEndpoint + guardarFaseAnualSeguimiento + idJardin+ "/" + idAnioFase + "/" + orden, FaseAnualDTO, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_finalizarFaseAnual(idJardin:number, idAnioFase:Number ){    
    return this.http.post(environment.apiEndpoint + finalizarFaseAnual + idJardin + "/" + idAnioFase, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_finalizarFaseAnualSeguimiento(idJardin:number, idAnioFase:Number ){    
    return this.http.post(environment.apiEndpoint + finalizarFaseAnualSeguimiento + idJardin + "/" + idAnioFase, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_borrarAccionesFaseAnual(idJardin:number, idAccion:number){    
    return this.http.post(environment.apiEndpoint + borrarAccionesFaseAnual + idJardin + "/" + idAccion, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_crearBlockNotaPM(blockNotasModel : BlockNotasPMModel): Observable<any>{          
    return this.http.post(environment.apiEndpoint + crearBlockNotaPM , blockNotasModel, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_actualizarBlockNotaPM(blockNotasModel : BlockNotasPMModel): Observable<any>{          
    return this.http.post(environment.apiEndpoint + actualizarBlockNotaPM , blockNotasModel, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getMisBlockNotasPM(idJardin:number): Observable<any>{    
    return this.http.post(environment.apiEndpoint + "planMejora/" + idJardin + "/getMisBlockNotas"  , null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_deleteBlockNotaPM(blockNotasModel : BlockNotasPMModel): Observable<any>{    
    return this.http.post(environment.apiEndpoint + deleteBlockNotaPM , blockNotasModel, httpOptions).pipe(
      catchError(this.handleError)
    );
  }



  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

}
